<template>
  <div class="cmsdetail" style="background:#f9f9f9;padding-bottom:50px;">
    <div class="container_wrap">
      <div class="cart default">
        <!-- <el-steps :active="1" align-center class="default">
          <el-step title="选择产品" description></el-step>
          <el-step title="支付购买" description></el-step>
          <el-step title="提交信息" description></el-step>
          <el-step title="订单执行" description></el-step>
          <el-step title="订单完成" description></el-step>
        </el-steps> -->
        <div class="cart-list">
          <div class="cart-list-address">
            <div class="default-t" style="font-size:18px; font-weight: bold;">收货人信息</div>
            <el-button class="" @click="add_address_visible=true">新增地址</el-button>
          </div>
          <div class="address-row">
            <div>{{address_row.name}}</div>
            <div style="margin-right:20px">({{address_row.phone}})</div>
            <div>{{address_row.province}} {{address_row.city}} {{address_row.county}} {{address_row.address}}</div>
          </div>
          <div class="address-solid"></div>
          <div v-if="!check_address_visible" style="text-align: center;" @click="check_address_visible=true" class="address-more-box">
            <span class="address-more">更多地址</span>
            <b class="address-more-icon"></b>
          </div>
          <div v-for="(item,i) in addressList" v-if="check_address_visible">
            <div class="address-item-row" @click="onAddressCheck(item)">
              <div>{{item.name}}</div>
              <div style="margin-right:20px">({{item.phone}})</div>
              <div>{{item.province}} {{item.city}} {{item.county}} {{item.address}}</div>
            </div>
          </div>
          <div v-if="check_address_visible" style="text-align: center;" @click="check_address_visible=false" class="address-souqi-box">
            <span class="address-souqi">收起地址</span>
            <b class="address-souqi-icon"></b>
          </div>
          <div class="default-t">确认订单</div>
          <el-table
            ref="multipleTable"
            :data="goods_items"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <!-- <el-table-column type="selection" width="55">
            </el-table-column>-->
            <el-table-column label width="120">
              <template slot-scope="scope">
                <img class="cart-product-img" :src="scope.row.pic_url" alt srcset />
              </template>
            </el-table-column>
            <el-table-column label=" " width="320">
              <template slot-scope="scope">
                <p class="p1 show-two-row">{{ scope.row.title }}</p>
              </template>
            </el-table-column>
            <el-table-column prop label width="220">
              <template slot-scope="scope">
                <p class="show-two-row">{{ scope.row.sku.sku_formart }}</p>
              </template>
            </el-table-column>
            <el-table-column prop label width="220">
              <template slot-scope="scope">
                <p class="default">单价:¥{{ scope.row.price }}</p>
                <p class="default">数量:{{ scope.row.count}}</p>
              </template>
            </el-table-column>

            <el-table-column prop="name" label width="220">
              <template slot-scope="scope">
                <b class="default">
                  小记:
                  <span style="color:#0175c2;">¥{{(scope.row.price)*scope.row.count }}</span>
                </b>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pay-box"> 
          <div class="pay-items-box">
            
            <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 5 }"
            placeholder="请输入其他诉求"
            v-model="formData.note"
            class="inputSizeClass"
          ></el-input>
            <div class="items-1 flex-start">
              
              <!-- <div
                :class=" pay_type==3 ? 'flex-start pointer ye-pay back-pay' :'flex-start pointer ye-pay'"
                @click="onpPayBtn(3)"
              >
                <img src="../../../assets/images/activity/icon-pay-y.png" alt srcset />
                零钱支付
              </div> -->
            </div>
            <div class="msg default">
              <!-- <p >当前您的账户（{{ balance.phone }}）余额：¥{{ balance.balance}}</p>
                    <p v-if="balance.balance < pay_price">当前余额不满足您目前的订单金额，请选择其他支付方式
                        先 <span class="top-up">充值</span> 或
              </p>-->
              <!-- <div>
                        温馨提示：受银行处理时间影响，线下汇款方式到账会有延误，强烈建议采用支付宝、微信实时到账。</br>
                        开户名称：徐州好推网络科技有限公司</br>
                        开户银行: 中国工商银行徐州市淮海东路支行</br>
                        银行账号： 1106020409210161841
                    </div>
                    <div>
                        <p style="margin: 10px 0;">上传转账截图仅供客服审核!</p>
                        <el-upload action="" list-type="picture-card" :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove" :http-request="uploadFile" :file-list="fileList">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible">
                            <img width="100%" :src="dialogImageUrl" alt="">
                        </el-dialog>

              </div>-->
            </div>
          </div>
          <!-- <div v-if="pay_type==3">
                <div class="offline-add pointer" @click="offlineAdd">提交审核</div>
          </div>-->
          <div class="jsy-zhifu">
            <table class="zhifu-table default" width="400">
              <tr>
                <td width="200">{{ goods_items.length }}种商品，总商品金额：</td>
                <td width="200" style="text-align:left;">
                  <p>
                    ¥
                    <span id="moneys">{{ goods_price }}</span>
                  </p>
                </td>
              </tr>
              <tr>
                            <td>运费：</td>
                            <td style="text-align:left;">
                                <p>¥<a id="yhmoney">{{express_price}}</a></p>
                            </td>
              </tr>
              <tr>
                <td>应支付金额：</td>
                <td style="text-align:left;">
                  <p>
                    <span>
                      ¥
                      <a id="money">{{ pay_price }}</a>
                    </span>
                  </p>
                </td>
              </tr>
            </table>
            <div class="jsy-zf" v-if="!pay_loading">
              <a href="javascript:;" @click="orderPay">立即支付</a>
            </div>
            <div class="jsy-zf" v-if="pay_loading">
              <a href="javascript:;">获取信息中...</a>
            </div>
            <!-- <div class="jsy-hg">
                    <a href="./cartindex/">返回修改订单</a>
            </div>-->
          </div>
        </div>
      </div>
      <div class="pay-ye-box" v-if="pay_visible">
        <div class="pay-ye">
          <p class="pay-box-title default">订单支付</p>
          <p class="pay-price default">¥{{ pay_price }}</p>
          <el-input
            v-if="selectedPayType == 'balance'  && havePayPassword==true"
            placeholder="请输入密码"
            v-model="password"
            show-password
          ></el-input>
          <el-input
            v-if="selectedPayType == 'balance'  && havePayPassword==false"
            placeholder="请设置支付密码"
            v-model="password"
            show-password
          ></el-input>
          <el-input
            v-if="selectedPayType == 'balance' && havePayPassword==false"
            style="margin-top: 10px;"
            placeholder="请再次输入支付密码"
            v-model="password2"
            show-password
          ></el-input>

          <span class="pay-button" v-if="!loading" @click="balancePay">确认支付</span>
          <p class="not-pay" v-if="!loading" @click="notPay">取消支付</p>
          <el-button type="primary" v-if="loading" class="pay-button" :loading="loading">正在支付</el-button>
        </div>
      </div>
    </div>
    <div class="add-address-box" v-if="add_address_visible">
      <div class="add-address-box-form">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div class="default" style="padding-left:20px;font-size:18px;padding-bottom:10px">新增地址</div>

          <el-form-item label="收货人" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="ruleForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="地区选择" prop="area_key">
            <el-cascader
              style="width:500px"
              v-model="area_key"
              :props="{ label: 'title' }"
              :options="areaOptions"
              @change="handleChange"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址" prop="address">
            <el-input v-model="ruleForm.address"></el-input>
          </el-form-item>
          <el-form-item label="默认地址" prop="is_default">
            <el-switch v-model="ruleForm.is_default"></el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">新建</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
            <el-button @click="add_address_visible=false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <ElPayDialog
              :show="payDialogShow"
              scene="goods"
              :ids="orderIds"
              @onPayError="onPayError"
              @onPaySuccess="onPaySuccess"
              @onPayClose="onPayClose"
            />
  </div>
</template>
<script>

import Vue from "vue";

import ElPayDialog from "@/components/ElPayDialog";

export default {
  name: "OrderPay",
  components: {
    ElPayDialog
  },
  data() {
    return {
      //   breadData: [{ name: "首页",link:"/" },{ name: "萌星商城",link:"/goodslist" }], //面包屑的内容
      add_address_visible: false,
      check_address_visible:false,

      payDialogShow: false,
      checked: false,
      pay_visible: false,
      loading: false,
      pay_loading: false,
      password: "",
      express_price:'',
      password2: "",
      multipleSelection: [],
      formData: {
        needLoadingIndicator: true,
        address_id: 0,
        goods_items: [],
        notes: {},
        coupon_used: {}
      },

      pay_price: 0,
      goods_price: 0,
      order_list: [],
      warnings: [],
      loginShow: false,
      goods_items: [],
      pay_type: 1,
      balance: {},
      orderIds: [],

      selectedPayType: "balance",
      havePayPassword: false,
      price: "",
      types: [],
      list: [],
      order_title: "",

      dialogImageUrl: "",
      dialogVisible: false,
      ossAccessTokenURL: "https://h5.dierqudao.com/aliOssSts.php",
      ossFileURL: "https://cheeseman.oss-cn-hangzhou.aliyuncs.com",
      fileList: [],
      ruleForm: {
        name: "",
        phone: "",
        area_key: "",
        province: "",
        city: "",
        county: "",
        address: "",
        is_default: true
      },
      address_row: {},
      area_key: [],
      areaOptions: [],
      rules: {
        name: [
          { required: true, message: "请输入收件人姓名", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入收件人姓名", trigger: "blur" }
        ],
        address: [
          { required: true, message: "请输入收件人姓名", trigger: "blur" }
        ],
        area_key: [{ required: true, message: "请选择地区", trigger: "blur" }]
      },
      addressList:[]
    };
  },
  
  mounted() {
    this.getOrderForm();
    this.getArea();
    this.getAddressList();
  },
  methods: {
    onAddressCheck(item){
      this.address_row=item
    },
    getAddressList() {
      let that = this;
      that.$api.get("/api/user/addressList", {}, res => {
        that.addressList = res.data;
      });
    },
    handleChange(value) {
      console.log(value);
      this.ruleForm.area_key = value[value.length - 1];
      this.areaOptions.map((item, i) => {
        if (item.value == value[0]) {
          this.ruleForm.province = item.label;
          item.children.map((chil, c) => {
            if (chil.value == value[1]) {
              this.ruleForm.city = chil.label;
              chil.children.map((last, c) => {
                if (last.value == value[2]) {
                  this.ruleForm.county = last.label;
                }
              });
            }
          });
        }
      });
      console.log(this.formData);
    },
    onPayError() {
      let that = this;
      console.log("onPayError 支付失败");
      that.payDialogShow = false;

      that.$toast("支付失败");

      rbLink(
        {
          name: "orderList",
        },
        "replace"
      );
    },
    onPaySuccess() {
      let that = this;
      console.log("onPaySuccess 支付成功");
      that.payDialogShow = false;

      appEvent({
        name: "orderList",
        query: {},
      });

      setTimeout(function () {
        rbLink(
          {
            name: "orderList",
            query: {},
          },
          "replace"
        );
      }, 500);
    },
    onPayClose() {
      let that = this;
      console.log("onPayClose 支付关闭");
      that.payDialogShow = false;

      setTimeout(function () {
        rbLink(
          {
            name: "orderList",
          },
          "replace"
        );
      }, 500);
    },
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.$api.get(
            "/api/user/addressAdd",
            {
              //$name, $phone, $address ,$area_key,$province,$city,$county,$is_default=''
              name: that.ruleForm.name,
              phone: that.ruleForm.phone,
              address: that.ruleForm.address,
              area_key: that.ruleForm.area_key,
              province: that.ruleForm.province,
              city: that.ruleForm.city,
              county: that.ruleForm.county,
              is_default: that.ruleForm.is_default ? 1 : 2
            },
            res => {
              console.log(res);
              that.selectAddress = res.data;
              that.add_address_visible = false;
              that.getOrderForm()
              that.getAddressList()
              that.ruleForm = {
                name: "",
                phone: "",
                area_names_string: "",
                area_key: "",
                address: "",
                province: "",
                city: "",
                county: "",
                is_default: true
              };
              // that.onChange();
            }
          );
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    offlineAdd() {
      let that = this;
      post("/api/order/orderAdd", that.formData, res => {
        that.orderIds = res.data.ids;
        that.payDialogShow=true
        return
       // that.onOfflinePay(res.data.ids);
        console.log("余额支付");
      });
    },
    onOfflinePay(ids) {
      let that = this;
      post(
        "/api/order/onOfflinePay",
        { id: ids[0], pay_type: "offline", pay_pics: that.fileList },
        res => {
          console.log(res);
          that.$message.success("保存成功!");

          window.location.href = that.url + "/subinfo?id=" + ids[0];
        },
        res => {}
      );
    },
    orderPay() {
      //立即支付按钮
      let that = this;
      that.pay_loading = true;
      that.formData.address_id = that.address_row.id;
      that.$api.post("/api/order/orderAdd", that.formData, res => {
        that.orderIds = res.data.ids;
        that.orderIds = res.data.ids;
        that.payDialogShow=true
        return
        if (that.pay_type == 1) {
          console.log(res.data.ids);
          localStorage.setItem("orderIds", JSON.stringify(res.data.ids));
          localStorage.setItem("order_code", res.data.order_code);
          localStorage.setItem("order_title", that.order_title);
          // that.pay_loading = false;
          that.$router.push({ path: "/weixin_pay" });
          console.log("微信支付");

        } else if (that.pay_type == 2) {
          console.log("支付宝");
          that.pay_loading = false;
          that.$message.success("支付方式正在申请中");
        } else {
          that.getOrderPayType();
          that.pay_visible = true;
          that.pay_loading = false;
          console.log("余额支付");
        }
      });
    },

    //下单这儿继续
    getOrderPayType() {
      let that = this;
      let params = {
        ids: that.orderIds,
        scene: "goods"
      };
      that.$api.post("/api/order/getOrderPayTypes", params, res => {
        that.price = res.data.pay.price;
        that.types = res.data.pay.types;
        that.list = res.data.list;
        // that.selectedPayType = res.data.selectedPayType;
        that.havePayPassword = res.data.havePayPassword;
      });
    },
    notPay() {
      this.pay_visible = false;
    },

    balancePay() {
      //余额支付确定
      let that = this;
      this.loading = true;
      let params = {
        orders: that.list,
        type: "balance",
        password: that.password,
        password2: that.password2
      };
      that.$api.post(
        "/api/order/orderpay",
        params,
        res => {
          that.loading = false;
          if (res.code != 200) {
            that.$message.error(res.msg);
          } else {
            that.$message.success("支付成功");
            that.$router.push({ path: "/orderlist" });
          }
          that.notPay();
        },
        res => {
          console.log(res);
          that.loading = false;
          that.$message.error(res.msg);
        }
      );
    },
    onpPayBtn(value) {
      console.log(value);
      this.pay_type = value;
      this.pay_type = value;
    },
    getOrderForm() {
      let that = this;
      that.formData.goods_items = JSON.parse(
        localStorage.getItem("order_check_goods_items")
      );
      that.$api.post(
        "/api/order/formdata",
        that.formData,
        res => {
          that.address_row = res.data.address;
          that.formData.buyer = res.data.buyer;
          that.order_list = res.data.order_list;
          that.goods_items = res.data.order_list[0].goods_items;
          that.express_price = res.data.order_list[0].express_price;
          that.goods_price = res.data.order_list[0].goods_price;
          that.pay_price = res.data.pay_price;
          that.balance = res.data.balance;
          if (res.data.order_list[0].goods_items.length > 1) {
            that.order_title =
              res.data.order_list[0].goods_items[0].title + "等服务";
          } else {
            that.order_title = res.data.order_list[0].goods_items[0].title;
          }
          // 判断有没有warning
          if (res.data.warnings.length > 0) {
            this.$message.error(res.data.warnings[0]);
            that.warnings = res.data.warnings;
            that.submitDisabled = true;
          } else {
            that.submitDisabled = false;
          }
        },
        res => {
          that.$message.error(res.msg);
          if (res.code == "401") {
            window.location.href = "/login";
          }
        }
      );
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    uploadFile(evt) {
      console.log("evt");
      console.log(evt);

      var that = this;
      console.log(that.ossFileURL);
      evt.onProgress({ percent: 0 });
      OSS.urllib.request(this.ossAccessTokenURL, { method: "GET" }, function(
        err,
        response
      ) {
        let result;
        if (err) {
          that.$message.error("上传异常:" + err);
          console && console.error(err);
          evt.onError(100);
          return;
        }
        try {
          result = JSON.parse(response);
        } catch (e) {
          return alert("parse sts response info error: " + e.message);
        }
        var client = new OSS({
          accessKeyId: result.data.AccessKeyId,
          accessKeySecret: result.data.AccessKeySecret,
          stsToken: result.data.SecurityToken,
          endpoint: result.data.endpoint,
          bucket: result.data.bucket,
          secure: true
        });
        var suffix = evt.file.name
          .toLowerCase()
          .split(".")
          .splice(-1)[0];
        console.log(that.ossFileURL);
        var myDate = new Date();
        var file_save_name =
          "uploader/000/user-xxx/" + evt.file.uid + "." + suffix;
        client
          .multipartUpload(file_save_name, evt.file)
          .then(function(result) {
            evt.onSuccess();
            console.log(that.ossFileURL);
            var file = {
              uid: evt.file.uid,
              url: that.ossFileURL + "/" + file_save_name,
              name: evt.file.name,
              save_name: file_save_name
            };
            evt.onProgress({
              percent: 100
            });
            that.fileList.push(file);
            that.$message.success(evt.file.name + "上传成功");
          })
          .catch(function(err) {
            evt.onError();
            console.log(err);
            that.$message.error(evt.file.name + "上传失败");
          });
      });
    },
    getArea() {
      let that = this;
      that.$api.get("/api/utils/areaTree", {}, res => {
        that.areaOptions = res.data;
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.address-more-box , .address-souqi-box{
  cursor: pointer;
  margin: 10px 20px;

}
 
.address-more-icon {
  display: inline-block;
  vertical-align: middle;
  height: 10px;
  line-height: 10px;
  width: 9px;
  margin-left: 5px;
  background: url("../../../assets/images/addr-i.png") no-repeat 0 0;
}
.address-souqi-icon {
  display: inline-block;
  vertical-align: middle;
  height: 10px;
  line-height: 10px;
  width: 9px;
  margin-left: 5px;
  background: url("../../../assets/images/addr-i.png") no-repeat 0 -10px;
}
.address-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 20px; 
  
}
.address-solid{
  height: 4px;
  width: 100%;
  background: url("../../../assets/images/address-line.png") center;
}
.address-item-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 20px;
  cursor: pointer;
}
.address-item-row:hover {
  background: #1981ff;
  color: #fff;
}
.demo-ruleForm {
  width: 600px;
  background: #fff;
  padding: 20px 10px;
  border-radius: 20px;
  padding-right: 40px;
}
.add-address-box {
  width: 100%;
  position: fixed;
  height: 100vh;
  top: 0;
  position: fixed;
  background: rgba(0, 0, 0, 0.3);
  z-index: 99;
}
.add-address-box-form {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cart-list-address {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.add-address {
  color: blue;
  cursor: pointer;
}
.pointer {
  cursor: pointer;
}
.breadcrumb {
  margin-top: 21px;
  margin-left: 23px;
  margin: 21px 0 20px 23px;
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
}
.cmsdetail {
  width: 100%;
  background: #f4faff;
  height: 100%;
  overflow: hidden;
}
.cart {
  width: 1200px;
  margin: 20px auto;
}
.cart .cart-list {
  width: 1160px;
  margin: 20px auto;
  background: #fff;
  padding: 20px;
}
.cart .cart-list .el-input-number {
  width: 120px;
}
.cart .cart-list .el-input-number .el-input-number__decrease {
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cart .cart-list .el-input-number .el-input-number__increase {
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cart .cart-list .cart-product-img {
  width: 90px;
  height: 90px;
}
.cart .cart-list .cart-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0 10px 15px;
  background: #e6e6e6;
  margin-top: 10px;
}
.cart .cart-list .cart-bottom .bottom-left {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cart .cart-list .cart-bottom .bottom-left .check-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cart .cart-list .cart-bottom .bottom-left .check-box .el-checkbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cart .cart-list .cart-bottom .bottom-left div {
  margin-right: 30px;
  display: flex;
  align-items: center;
}
.cart .cart-list .cart-bottom .bottom-left div img {
  margin-right: 5px;
  width: 25px;
  height: 25px;
}
.cart .cart-list .cart-bottom .bottom-right {
  padding-right: 30px;
}
.cart .cart-list .cart-bottom .bottom-right div {
  margin-left: 30px;
}
.cart .cart-list .cart-bottom .bottom-right div .num-s {
  color: #0175c2;
}
.cart .pay-box {
  margin: 20px auto;
  // height: 500px;
  width: 100%;
  background: #fff;
  padding: 20px 0;
}
.cart .pay-box .pay-title {
  padding: 0 20px;
}
.cart .pay-box .pay-items-box {
  padding: 0 40px;
}
.cart .pay-box .pay-items-box .items-1 {
  margin-top: 20px;
}
.cart .pay-box .pay-items-box .items-1 div {
  width: 120px;
  margin-right: 20px;
  border: 1px solid #ccc;
  padding: 5px 0 5px 30px;
}
.cart .pay-box .pay-items-box .items-1 div img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.cart .pay-box .pay-items-box .items-1 div:hover {
  border: 1px solid #0175c2;
  background: url("../../../assets/images/activity/jsy_xz.png") right bottom
    no-repeat;
}
.back-pay {
  border: 1px solid #0175c2 !important;
  background: url("../../../assets/images/activity/jsy_xz.png") right bottom
    no-repeat;
}
.cart .pay-box .pay-items-box .items-1 .active {
  border: 1px solid #0175c2;
  background: url("../../../assets/images/activity/jsy_xz.png") right bottom
    no-repeat;
}
.cart .pay-box .pay-items-box .msg {
  margin-top: 10px;
}
.cart .pay-box .pay-items-box .msg p {
  margin-top: 10px;
}
.cart .pay-box .pay-items-box .msg .top-up {
  padding: 3px 10px;
  background: #0175c2;
  color: #fff;
  border-radius: 5px;
}
.cart .pay-box .jsy-zhifu {
  min-height: 100px;
  height: auto;
  overflow: hidden;
  background: #fff;
  margin: 40px auto;
  padding-right: 40px;
}
.cart .pay-box .jsy-zhifu table.zhifu-table {
  width: 400px;
  height: 130px;
  float: right;
}
.cart .pay-box .jsy-zhifu table.zhifu-table tr td {
  text-align: right;
  font-size: 16px;
  color: #333;
  padding: 0;
}
.cart .pay-box .jsy-zhifu table.zhifu-table tr td p {
  padding-left: 100px;
  color: #0175c2;
}
.cart .pay-box .jsy-zhifu table.zhifu-table tr td span {
  color: #0175c2; 
  font-size: 18px;
}
.cart .pay-box .jsy-zhifu .jsy-zf {
  width: 230px;
  height: 50px;
  float: right;
  clear: both;
  background: #0175c2;
  border-radius: 5px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  text-align: center;
  line-height: 50px;
  margin-top: 20px;
}
.cart .pay-box .jsy-zhifu .jsy-zf a {
  display: block;
  color: #fff;
  font-size: 18px;
}
.cart .pay-box .jsy-zhifu .jsy-hg {
  width: 230px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  float: right;
  clear: both;
  margin-bottom: 30px;
}
.cart .pay-box .jsy-zhifu .jsy-hg a {
  color: #666;
  font-size: 16px;
  font-weight: normal;
}
.pay-ye-box {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  z-index: 9;
}
.pay-ye-box .pay-ye {
  margin: 100px auto;
  width: 400px;
  background: #fff;
  display: flex;
  padding: 40px 40px 60px 40px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
}
.pay-ye-box .pay-ye .pay-box-title {
  margin-bottom: 30px;
  text-align: center;
  font-size: 22px;
  color: #333;
}
.pay-ye-box .pay-ye .pay-price {
  color: #0175c2;
  font-size: 20px;
  margin-bottom: 10px;
}
.pay-ye-box .pay-ye .not-pay {
  margin-top: 10px;
  text-align: center;
  font-size: 14px;
  color: #ccc;
  cursor: pointer;
}
.pay-ye-box .pay-ye .pay-button {
  width: 80%;
  height: 50px;
  background: #0175c2;
  line-height: 50px;
  color: #fff;
  border-radius: 10px;
  text-align: center;
  margin-top: 30px;
  cursor: pointer;
  padding: 0 !important;
  border: none !important;
}
.default-t{
  font-size: 18px;
  font-weight: bold;
}
.offline-add {
  width: 148px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  color: #fff;
  background: #0175c2;
  border-radius: 5px;
  margin: 20px 0 0 40px;
}
</style>



// WEBPACK FOOTER //
// OrderPay.vue?4574ede7